
import PropTypes from 'prop-types'

const Image = ({ className, src }) => {

  return (
    <div
      style={{
        display: 'flex',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundImage: `url(${src})`,
        ...className
      }}/>
  )
}

Image.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
}

export default Image
